import {Component, Prop} from "vue-property-decorator";
import ItemSelectModal from "@/assets/common/Modal/ItemSelectModal/ItemSelectModal.vue";
import Modal from "@/assets/common/Modal/Modal.vue";

@Component({
    components: {
        Modal
    }
})
export default class MaterialSelectModal extends ItemSelectModal {
    @Prop({default: () => "資材"})
    itemKindName!: string

    @Prop({default: () => "/materials"})
    apiPath!: string;

    @Prop({default: () => []})
    options!: string[];

    @Prop({default: () => true})
    multiple!: boolean

    @Prop({default: () => true})
    editable!: boolean

    // バリデーションチェックパラメータのオーバーライド
    validateParam = { nameLength: 100 }
}

